// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__C7k-3","content":"GlobalSearch_content__sjPNB"};